// src/components/Gantt/GanttProjectGroup.jsx
import { memo } from "react";
import { taskWord } from "../../utils/pluralize";
import { UNKNOWN_PROJECT_ID } from "./geometry";
import { GanttRow } from "./GanttRow";

function GanttProjectGroupImpl({
  project,
  visibleRows,
  DW,
  employeesById,
  projectsById,
  openTask,
  openProject,
  getTaskSpent,
  vacOverlap,
  expandedTasks,
  onToggleTask,
  onDragStart,
  detectDragMode,
  db,
  user,
  canEdit,
  onMove,
  onDelete,
  onCopy,
  onMakeTemplate,
  registerRowEl,
}) {
  const canOpenProject = !!openProject && project.id !== UNKNOWN_PROJECT_ID;
  const priorityClass = project.priority
    ? `gantt-pdot--${String(project.priority).toLowerCase()}`
    : "";

  if (visibleRows.length === 0) return null;

  return (
    <div>
      <div className="gantt-group">
        <div
          className={`gantt-group-name${canOpenProject ? " cursor-pointer underline" : ""}`}
          role={canOpenProject ? "button" : undefined}
          tabIndex={canOpenProject ? 0 : undefined}
          onClick={canOpenProject ? () => openProject(project.id) : undefined}
          onKeyDown={
            canOpenProject
              ? (e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    openProject(project.id);
                  }
                }
              : undefined
          }
          title={canOpenProject ? "Открыть проект" : project.name}
        >
          <span className={`pdot${priorityClass ? " " + priorityClass : ""}`} />
          {project.code} · {project.name}
          <span className="mut sm ml-2">
            ({visibleRows.length} {taskWord(visibleRows.length)})
          </span>
        </div>
      </div>
      {visibleRows.map(({ id, level, hasChildren, node, indices }) => {
        const employee = node.assigneeId
          ? employeesById.get(node.assigneeId)
          : null;
        const taskProject = projectsById.get(node.projectId) || project;
        return (
          <GanttRow
            key={id}
            task={node}
            level={level}
            hasChildren={hasChildren}
            expanded={expandedTasks.has(id)}
            onToggle={onToggleTask}
            indices={indices}
            DW={DW}
            employee={employee}
            project={taskProject}
            openTask={openTask}
            getTaskSpent={getTaskSpent}
            vacOverlap={vacOverlap}
            onDragStart={onDragStart}
            detectDragMode={detectDragMode}
            db={db}
            user={user}
            canEdit={canEdit}
            onMove={onMove}
            onDelete={onDelete}
            onCopy={onCopy}
            onMakeTemplate={onMakeTemplate}
            registerRowEl={registerRowEl}
          />
        );
      })}
    </div>
  );
}

export const GanttProjectGroup = memo(GanttProjectGroupImpl);
